import { NumberFormatter } from '@internationalized/number'

const currentFormater = new NumberFormatter('pt-BR', {
  style: 'currency',
  currency: 'BRL',
})

export const currency = (value: number) => {
  if (/^\d+\.\d{2}$/.test(value.toString())) {
    return currentFormater.format(Number(value))
  }

  const price = Number(String(value).replace(/(\d{2}$)/g, '.$1'))
  return currentFormater.format(price)
}


export const formatToBRL = (value: number): string => {
  return new Intl.NumberFormat("pt-BR", {
    style: "currency",
    currency: "BRL",
  }).format(value);
};

export const formatStringToBRL = (valueStr: string): string => {
  if (valueStr === '') return ''
  const numericValue = parseFloat(valueStr.replace(",", "."));
  return formatToBRL(numericValue);
};

export const formatNumberOnly = (valueStr: string): string => {
  const numericValue = parseFloat(valueStr.replace(",", "."));
  return new Intl.NumberFormat("pt-BR", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(numericValue);
};